import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MvMsalService } from '@aot/host-app-widgets-demo';
import { Observable } from 'rxjs';

/* istanbul ignore file */
  @Injectable()
  export class MVHttpInterceptor implements HttpInterceptor {
    constructor(private mvMsalService: MvMsalService) {}
    intercept(
      request: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {

      let token = this.mvMsalService.getAccessToken();
      
      if (token) {
        request = request.clone({
          headers: request.headers.set('Authorization', `Bearer ${token}`)
        });
      }
      return next.handle(request);
    }
  }
